import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import ViewData from "./ViewData";
import UserInfo from "@utils/UserInfo";
import { WarehouseListContainer } from "./WarehouseTruckList.styled";
import AddEditTrucks from "../AddEditTrucks/AddEditTrucks";
import "./WarehouseTruckList.scss";
/**
 * WarehouseList List,
 * Path - /companies/{companyId}/hauliers/{haulierId}/warehouses
 * @see See [CenterProducts Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2944892929/Company+view+page+-+Warehouses)
 * @component
 */
const WarehouseTruckList = (props) => {
  const {
    t,
    carrierId,
    companyId,
    companyName,
    companyStatus,
    warehouseData,
    setIsRefreshWarehouse,
    isRefreshWarehouse,
    countryId,
  } = props;

  const [isRefreshList, setIsRefreshList] = useState(false);

  const [isAddWarehouseTruckPopupVisible, setAddWarehouseTruckPopupVisible] =
    useState(false);

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  const updateWarehouseRefeshStatus = () => {
    setIsRefreshWarehouse(true);
  };

  useEffect(() => {
    if (isRefreshWarehouse) {
      setIsRefreshWarehouse(false);
    }
  }, [isRefreshWarehouse]);

  const createWarehouseTruck = () => {
    setAddWarehouseTruckPopupVisible(true);
  };

  const closeWarehouseTruckPopupVisible = () => {
    setAddWarehouseTruckPopupVisible(false);
  };

  return (
    <WarehouseListContainer className="center-products-list">
      <ViewData
        isRefreshList={isRefreshList}
        updateRefeshStatus={updateRefeshStatus}
        carrierId={carrierId}
        companyId={companyId}
        countryId={countryId}
        companyStatus={companyStatus}
        trucks={warehouseData.trucks ? warehouseData.trucks : []}
        warehouseId={warehouseData.id}
        createWarehouseTruck={createWarehouseTruck}
        updateWarehouseRefeshStatus={updateWarehouseRefeshStatus}
      />
      {isAddWarehouseTruckPopupVisible && (
        <AddEditTrucks
          carrierId={carrierId}
          companyId={companyId}
          countryId={countryId}
          warehouseData={warehouseData}
          trucks={warehouseData.trucks ? warehouseData.trucks : []}
          onClose={closeWarehouseTruckPopupVisible}
          updateWarehouseRefeshStatus={updateWarehouseRefeshStatus}
        />
      )}
    </WarehouseListContainer>
  );
};

WarehouseTruckList.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(WarehouseTruckList);
